$active-sidebar-width: 310px;
$collapsed-sidebar-width: 120px;

.Wrapper {
  min-height: 100vh;
}

.Header {
  min-height: 50px;
}

.Main {
  padding: 26px 32px;
  &WithActiveSidebar {
    width: calc(100% - #{$active-sidebar-width});
  }
  &WithCollapsedSidebar {
    width: calc(100% - #{$collapsed-sidebar-width});
  }
  > :global(.breadcrumb:not(:last-child)) {
    margin-bottom: 1rem;
  }
}

:global(.dropdown-trigger:focus-within > .dropdown-menu) {
  display: block;
}
